const bemMod = (base: string, mods: string[] = []): string[] => {
  return (mods || []).map((mod) => `${base}--${mod}`);
};

export default bemMod;
